import { render, staticRenderFns } from "./CreateTermDialog.vue?vue&type=template&id=04ee6586&scoped=true"
import script from "./CreateTermDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateTermDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateTermDialog.vue?vue&type=style&index=0&id=04ee6586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ee6586",
  null
  
)

export default component.exports